import * as React from 'react';
import {
    RenameAction as BaseRenameAction,
    ItemRenameAction as BaseItemRenameAction,
    IItemRenameActionProps as IBaseItemRenameActionProps,
    IRenameActionProps as IBaseRenameActionProps
} from '../../base/actions/rename/RenameAction';
import strings from '../../scope/actions/strings.resx';
import { injectInitialProps } from '../../../utilities/components/Props';
import { IDecoratedProps } from '../../../utilities/components/Decorators';
import { IRenameWizardProps } from '../../../controls/renameActionControl';
import { RenameDialog } from './RenameDialog';
import { CancelError } from '../../../utilities/async/CancelError';
import { IOperationActionCreator } from '../../../store/actions/implementOperation';
import { renameItemOperation, renameProgressKeyFacet } from '../../../operations/renameItem';
import { implementOperationWithProgress } from '../../../operations/progress';
import { renameProgressAddon } from '../../../operations/renameItem/RenameProgressAddon';

class RenameWizard extends React.PureComponent<IRenameWizardProps> {
    public render(): JSX.Element {
        const {
            resolve,
            reject,
            onRename,
            lockedWarningMessage,
            title,
            validator,
            fileExtensionText,
            oldName
        } = this.props;

        const onContinue = async (options: {
            name: string;
        }) => {
            resolve();

            if (onRename) {
                await onRename(options);
            }
        };

        const onCancel = async () => {
            reject(new CancelError());
        };
        let dialogTitle = (title) ? title : strings.Rename;

        return (
            <RenameDialog
                onContinue={ onContinue }
                onCancel={ onCancel }
                title={ dialogTitle }
                continueText={ strings.RenameCommit }
                name={ oldName }
                validator={ validator }
                fileExtensionText={ fileExtensionText }
                lockedWarningMessage={ lockedWarningMessage }
                warningDialogCancelText={ strings.cancelActionText }
                cancelText={ strings.cancelActionText }
            />
        );
    }
}

const renameItemWithProgress: IOperationActionCreator<typeof renameItemOperation.type> = implementOperationWithProgress({
    operationTypeFacet: renameItemOperation,
    progressKeyFacet: renameProgressKeyFacet,
    initializeBatch: () => renameProgressAddon
});

function injectRenameWizard(): Pick<IBaseItemRenameActionProps, 'renameWizard' | 'renameItem'> {
    return {
        renameWizard: RenameWizard,
        renameItem: renameItemWithProgress
    };
}

export type IItemRenameActionProps = IDecoratedProps<IBaseItemRenameActionProps, Pick<IBaseItemRenameActionProps, 'renameWizard'>, {}>;

export const ItemRenameAction: React.ComponentType<IItemRenameActionProps> =
    injectInitialProps(injectRenameWizard)(BaseItemRenameAction);

export type IRenameActionProps = IDecoratedProps<IBaseRenameActionProps, Pick<IBaseRenameActionProps, 'renameWizard'>, {}>;

export const RenameAction: React.ComponentType<IRenameActionProps> =
    injectInitialProps(injectRenameWizard)(BaseRenameAction);
